<template>
  <div class="row">
    <div class="col-sm-6" v-for="page in pages" :key="page.name">
      <router-link tag="div" :to="`/custom_table/${page.path}`" class="card card-admin">
        <div class="card-body text-center">
          <strong>
            {{ page.name }}
          </strong>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    pages: [
      { name: 'Layouts', path: 'schemas'},
      { name: 'Tabelas', path: 'tables'},
    ],
    withLogin: false,
  }),
  name: 'Index'
}
</script>

<style scoped>

.card-admin {
  cursor: pointer;
}
.card-admin:hover {
  transition: background-color 1s;
  background: #8080803d;
}

</style>